<template>
    <v-container app :fluid="true">
        <v-row>
            <v-col cols="4" class="pt-0">
                <v-text-field
                    v-model="search"
                    append-icon="fas fa-search"
                    label="Buscar variante"
                    hide-details
                    solo
                    dense
                    class="wost-text-input"
                ></v-text-field>
            </v-col>
            <v-col cols="8" class="pt-0">
                <v-btn 
                    @click="handleViewCreate" 
                    rised 
                    color="indigo" 
                    dark
                    class="float-right wost-btn-new" 
                    v-if="verifyPermission('crear_variantes')">
                    <v-icon dark left size="12">fas fa-plus</v-icon>Nueva Variante
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        class="wost-table"
                        :headers="headers"
                        :items="variants"
                        item-key="id"
                        :search="search"
                        height="62vh"
                        fixed-header
                        show-expand
                        :single-expand="true"
                        v-if="verifyPermission('listar_variantes')"
                    >

                        <template v-slot:expanded-item="{ item, headers }">
                            <td :colspan="headers.length" class="wost-td-expanded">
                                <variants-options :options="item.options"></variants-options>
                            </td>
                        </template>

                        <template v-slot:item.action="{ item }">
                            <div class="datatable-cell-wrapper">
                                <a href="#" 
                                    title="Editar" 
                                    class="btn-actions btn-edit" 
                                    @click="handleEditVariant(item)"
                                    v-if="verifyPermission('actualizar_variantes')">
                                    <v-icon color="amber" size="16">fas fa-pencil-alt</v-icon>
                                </a>
                                &nbsp;
                                <a v-if="item.status  === 'activo' && verifyPermission('inactivar_variantes')" 
                                    href="#" 
                                    title="Inactivar" 
                                    class="btn-actions btn-delete" 
                                    @click="changeStatus(item, 'inactivar')">
                                    <v-icon color="red darken-1" size="16">fas fa-minus-circle</v-icon>
                                </a>
                                <a v-else-if="item.status  === 'inactivo' && verifyPermission('activar_variantes')" 
                                    href="#" 
                                    title="Activar" 
                                    class="btn-actions btn-delete" 
                                    @click="changeStatus(item, 'activar')">
                                    <v-icon color="green darken-1" size="16">fas fa-check-circle</v-icon>
                                </a>
                            </div>
                        </template>

                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <create-update ref="createUpdate"></create-update>
    </v-container>
</template>

<script>
import {mapActions, mapState} from 'vuex';

import CreateUpdate from '../../components/variants/CreateUpdate';
import VariantsOptions from '../../components/variants/VariantsOptions';

export default {
    name: 'Variants',
    components: {
        CreateUpdate,
        VariantsOptions
    },
    data () {
        return {
            search: null,
            headers: [
                { text: '', value: 'data-table-expand', width: 10, class: 'header-table-expand' },
                { text: 'Nombre', value: 'name', sortable: false, class: 'header-table'},
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', align: 'end' }
            ],
        }
    },
    computed: {
        ...mapState('variants', [
            'variants',
            'variant_response'
        ])
    },
    methods: {
        ...mapActions('variants', [
            'getVariants',
            'change_status'
        ]),
        handleViewCreate () {
            this.$refs.createUpdate.show('Registrar variante', 'create');
        },
        handleEditVariant (variant) {
            let variantData = Object.assign({}, variant);
            this.$refs.createUpdate.show('Modificar variante', 'update', variantData);
        },
        changeStatus (variant, status) {
            this.$swal({
                title: "¿Desea confirmar?",
                text: "Confirma que desea " + status + " la variante",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Confirmar",
                cancelButtonText: "Cancelar",
            }).then( async (result) => {
                if(result.value){
                    if(result.value === true){
                        await this.change_status(variant);
                        if (this.variant_response == 'error') {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                title: 'ACTUALIZACION DE VARIANTE',
                                text: 'Ocurrió un error al cambiar estado de variante.'
                            });
                        } else {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                title: 'ACTUALIZACION DE VARIANTE',
                                text: 'El estado de variante fue actualizado de forma correcta.'
                            });
                        }
                    }
                }                    
            })
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    created () {
        this.getVariants();
    }
}
</script>

<style scoped>

</style>